exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#containerDiv[data-v-29e0978a] {\n  /* height: 100%; */\n  width: 100%;\n}\n#headerDiv[data-v-29e0978a] {\n  height: 10vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  width: 100%;\n  padding-bottom: 15px;\n}\n.section[data-v-29e0978a] {\n  height: 100%;\n  width: 33%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n#bodyDiv[data-v-29e0978a] {\n  /* height: 70%; */\n  width: 100%;\n}\n", ""]);

// exports
